<header class="header">

  <!-- ROW 1: Header Top (64px) - STICKY at top: 0 -->
  <div class="header-top">

    <!-- Left Side -->
    <div class="header-left">

      <!-- Hamburger Menu Toggle -->
      <button class="menu-toggle" (click)="onMenuToggle()">
        <div class="hamburger">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <!-- Dashboard Title + Date -->
      <div class="dashboard-title">
        <div class="dashboard-title-info">
          <h1>{{ dashboardTitle }}</h1>
          <span class="env-badge dev" *ngIf="!isProduction">DEVELOPMENT</span>

          <span class="dashboard-separator">•</span>
          <span class="dashboard-date">{{ currentDate }}</span>
        </div>
      </div>

      <!-- Quick Stats -->
      <div class="quick-stats">
        <div class="quick-stat" [class.active]="activeTab === 'todayOrders'" (click)="setActiveTab('todayOrders')">
          <span class="quick-stat-label">Today's Orders</span>
          <span class="quick-stat-value">{{ todayTotalDP }}</span>
        </div>
        <div class="quick-stat" [class.active]="activeTab === 'deliveries'" (click)="setActiveTab('deliveries')">
          <span class="quick-stat-label">Deliveries</span>
          <span class="quick-stat-value">{{ todayDelivery }}</span>
        </div>
        <div class="quick-stat" [class.active]="activeTab === 'pickup'" (click)="setActiveTab('pickup')">
          <span class="quick-stat-label">Pickup</span>
          <span class="quick-stat-value">{{ todayPickup }}</span>
        </div>
      </div>
    </div>

    <!-- Right Side -->
    <div class="header-actions">

      <!-- Drivers Active -->
      <button class="real-time-indicator" *ngIf="!isReceivingAdminPage" (click)="onDriversClick()">
        <span>Online Drivers: <span class="driver-count">{{active_driver_count}}</span></span>
        <div class="real-time-dot" [class.pulsing]="active_driver_count > 0"></div>
      </button>

      <!-- Search Box -->
      <div class="search-box">
        <svg class="search-icon" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>

        <input type="text" [(ngModel)]="searchQuery" (input)="onSearch()" class="search-input" />

        <div class="placeholder-container" *ngIf="!searchQuery">
          <span class="placeholder-text" *ngIf="isAnimating">
            {{ currentPlaceholder }}
          </span>
        </div>

        <svg *ngIf="searchQuery && searchQuery.length > 0" (click)="clearText()" class="cross-icon" width="16"
          height="16" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>

      <!-- Notifications Bell (click)="onNotificationsClick()"  -->
      <div class="notification-bell-wrapper">
        <button class="btn btn-secondary notification-badge" (click)="onNotificationsClick()" [class.active]="isOpen">
          <svg width="18" height="18" fill="currentColor" viewBox="0 0 20 20">
            <path
              d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
          </svg>
          <span class="badge-count" *ngIf="notificationCount > 0">{{ notificationCount }}</span>
        </button>

        <!-- Notification Dropdown moved here for correct alignment -->
        <div class="notification-dropdown" [class.active]="isOpen">
          <div class="dropdown-header">
            <h3 class="dropdown-title">Recent Notifications</h3>
            <button class="close-dropdown" (click)="toggleDropdown()">✕</button>
          </div>
          <div class="dropdown-content">
            <!-- Skeleton loading rows -->
            <ng-container *ngIf="!notificationListData">
              <div *ngFor="let i of [1,2,3,4,5]" class="notif-skeleton-row">
                <div class="notif-sk-icon"></div>
                <div class="notif-sk-body">
                  <div class="notif-sk-line notif-sk-title"></div>
                  <div class="notif-sk-line notif-sk-msg"></div>
                </div>
              </div>
            </ng-container>
            <!-- Empty State -->
            <div *ngIf="notificationListData && notificationListData.length === 0" class="empty-state">
              <p class="empty-state-title">No notifications</p>
              <p class="empty-state-text">You're all caught up!</p>
            </div>
            <!-- Notifications List -->
            <div *ngIf="notificationListData && notificationListData.length > 0">
              <div *ngFor="let notification of notificationListData">
                <div class="notification-item border-bottom"
                  [style.cursor]="notification.notif_type !== 'PO Message' ? 'pointer' : 'default'"
                  (click)="notification.notif_type !== 'PO Message' ? navigateToDetails(notification) : null">
                  <div class="notification-icon">
                      <svg *ngIf="notification.notif_type === 'Generic Notification'" xmlns="http://www.w3.org/2000/svg"
                      fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
                    </svg>
                    <svg *ngIf="notification.notif_type === 'Ticket Notification'" xmlns="http://www.w3.org/2000/svg"
                      fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
                    </svg>
                    <svg *ngIf="notification.notif_type === 'Order Notification'" xmlns="http://www.w3.org/2000/svg"
                      fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
                    </svg>
                  </div>
                  <div class="notification-content" *ngIf="notification.notif_type !== 'PO Message'; else noClick">
                    <div class="notification-title">
                      {{ notification.notif_type === 'Ticket Notification' ? 'Ticket ID: ' +
                      notification.notif_detail_id : notification.notif_type }}
                    </div>
                    <div class="notification-message">
                      <span class="notification-text">{{ notification.notification }}</span>
                      <span class="notification-meta">{{ notification.sent_at | dateAgo }}</span>
                    </div>
                  </div>
                  <ng-template #noClick>
                    <div class="notification-content">
                      <div class="notification-title">{{ notification.notif_type }}<span class="notification-meta">{{
                          notification.sent_at | dateAgo }}</span></div>
                      <div class="notification-message">{{ notification.notification }}</div>
                    </div>
                  </ng-template>
                  <div class="notification-actions">
                    <button class="notification-delete"
                      (click)="$event.stopPropagation(); deleteNotifications(notification.id)">✕<i
                        *ngIf="isDeleteLoading && isDeleteId == notification.id"
                        class="fa fa-spinner fa-spin"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown-footer" *ngIf="notificationListData && notificationListData.length > 0">
            <button class="clear-all-btn" (click)="clearAllNotifications()">Clear All<i *ngIf="isClearAllDeleteLoading"
                class="fa fa-spinner fa-spin"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ROW 2: Action Menu (46px) - STICKY at top: 64px -->
  <div class="action-menu" *ngIf="activeAction !== 'add' && activeAction !== 'edit' && !isReceivingAdminPage">

    <!-- Add Order -->
    <a [routerLink]="['/admin/orders/add']" class="action-menu-item"
      [class.active]="activeAction === 'add'">
      <svg fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
          clip-rule="evenodd" />
      </svg>
      Add Order
    </a>

    <!-- Locate Driver -->
    <a [routerLink]="['/admin/locate-driver']" class="action-menu-item"
      [class.active]="activeAction === 'locate'">
      <svg fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
          clip-rule="evenodd" />
      </svg>
      Locate Driver
    </a>

    <!-- Ask RTT AI -->
    <a href="javascript:void(0)" class="action-menu-item"
      (click)="onAskRTTAI();setActives('ai');toggleChatbot()" [class.active]="activeActions === 'ai'">
      <svg fill="currentColor" viewBox="0 0 20 20">
        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
      </svg>
      Ask RTT AI
    </a>

    <div class="spacer"></div>

    <!-- Notifications -->
    <!-- <a href="javascript:void(0)" class="action-menu-item"
      (click)="onNotifications();setActive('notify', onNotifications)" [class.active]="activeAction === 'notify'">
      <svg fill="currentColor" viewBox="0 0 20 20">
        <path
          d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
      </svg>
      Notifications
    </a> -->
    <!-- Beta Feedback -->
    <a [routerLink]="['/admin/beta-feedback']" class="action-menu-item beta-feedback-btn"
      [class.active]="activeAction === 'beta'">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z" />
        <path
          d="M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z" />
      </svg>
      Beta Feedback
    </a>

    <!-- Beta Feedback
    <button class="btn btn-secondary" (click)="onBetaFeedback()">
      Beta Feedback
    </button> -->

    <!-- Refresh Button -->
    <button class="btn btn-secondary refresh-btn" (click)="onRefresh()" title="Refresh Dashboard">
      <svg width="18" height="18" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>

</header>


<!-- Floating Button -->
<button *ngIf="showFlotingtoggel" class="floating-chatbot-btn" (click)="toggleChatbot()">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path fill-rule="evenodd"
      d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z"
      clip-rule="evenodd" />
  </svg>
</button>
<div class="chat-modal-overlay" [class.active]="isChatOpen">
  <div class="chat-modal" [class.active]="isChatOpen">
    <div class="chat-header">
      <div class="chat-header-left">
        <div class="chat-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="20">
            <path
              d="M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z" />
            <path
              d="M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z" />
          </svg>
        </div>
        <div class="chat-title">Ask RTT AI</div>
      </div>
      <div class="chat-header-actions">
        <button class="chat-action-btn" (click)="mintoggleChatbot()">—</button>
        <button class="chat-action-btn" (click)="closetoggleChatbot()">✕</button>
      </div>
    </div>

    <div class="chat-messages" #scrollContainer>
      <div *ngIf="showWelcome" class="welcome-message">
        <h3>Hello! I'm RTT AI Assistant</h3>
        <p>I can help you with orders, drivers, and deliveries.</p>
        <div class="quick-questions">
          <button class="quick-question-btn" (click)="askQuestion('Show me today deliveries')">🚚 Today's
            deliveries</button>
          <button class="quick-question-btn" (click)="askQuestion('Where is my order?')">📦 List of active
            drivers</button>
        </div>
      </div>

      <div *ngFor="let msg of messages" class="message" [ngClass]="msg.sender">

        <div class="message-bubble" [innerHTML]="msg.text"></div>

        <div class="message-time">{{ msg.time }}</div>
      </div>


      <div *ngIf="isTyping" class="typing-indicator active">
        <div class="typing-dots">
          <div class="typing-dot"></div>
          <div class="typing-dot"></div>
          <div class="typing-dot"></div>
        </div>
      </div>
    </div>

    <div class="chat-input-container">
      <div class="chat-input-wrapper">
        <input type="text" [(ngModel)]="userInput" (keyup.enter)="sendMessage()" placeholder="Ask RTT AI"
          class="chat-input">
        <button class="voice-btn" [class.recording]="isRecording" (click)="toggleVoice()"> <svg
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8.25 4.5a3.75 3.75 0 117.5 0v8.25a3.75 3.75 0 11-7.5 0V4.5z" />
            <path
              d="M6 10.5a.75.75 0 01.75.75v1.5a5.25 5.25 0 1010.5 0v-1.5a.75.75 0 011.5 0v1.5a6.751 6.751 0 01-6 6.709v2.291h3a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3v-2.291a6.751 6.751 0 01-6-6.709v-1.5A.75.75 0 016 10.5z" />
          </svg></button>
        <button class="send-btn" (click)="sendMessage()"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="currentColor">
            <path
              d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
          </svg></button>
      </div>
    </div>
  </div>
</div>




<div *ngIf="isOpen" class="notification-backdrop" (click)="toggleDropdown()"></div>

<div class="driver-modal-overlay" *ngIf="showDriverModal" (click)="closeDriverModal()">
  <div class="driver-modal">
    <div class="driver-modal-header">
      <h3 class="driver-modal-title">Online Drivers</h3>
      <a class="driver-modal-close" (click)="closeDriverModal()">×</a>
    </div>
    <div class="driver-modal-body">
      <div class="driver-list">
        <div class="driver-card active">
          <div class="driver-avatar-large">TR</div>
          <div class="driver-info">
            <div class="driver-name">Tony Rodriguez</div>
            <div class="driver-details">5 deliveries today • Last update: 2 min ago</div>
          </div>
          <div class="driver-status active">
            <div class="driver-status-dot"></div>
            <span>On Delivery</span>
          </div>
        </div>

        <div class="driver-card active">
          <div class="driver-avatar-large">AM</div>
          <div class="driver-info">
            <div class="driver-name">Anussh Malhotra</div>
            <div class="driver-details">4 deliveries today • Last update: 1 min ago</div>
          </div>
          <div class="driver-status active">
            <div class="driver-status-dot"></div>
            <span>On Delivery</span>
          </div>
        </div>

        <div class="driver-card active">
          <div class="driver-avatar-large">JK</div>
          <div class="driver-info">
            <div class="driver-name">John Kaur</div>
            <div class="driver-details">6 deliveries today • Last update: 5 min ago</div>
          </div>
          <div class="driver-status active">
            <div class="driver-status-dot"></div>
            <span>On Delivery</span>
          </div>
        </div>

        <div class="driver-card active">
          <div class="driver-avatar-large">MS</div>
          <div class="driver-info">
            <div class="driver-name">Maria Santos</div>
            <div class="driver-details">3 deliveries today • Last update: 3 min ago</div>
          </div>
          <div class="driver-status active">
            <div class="driver-status-dot"></div>
            <span>On Delivery</span>
          </div>
        </div>

        <div class="driver-card active">
          <div class="driver-avatar-large">DP</div>
          <div class="driver-info">
            <div class="driver-name">David Park</div>
            <div class="driver-details">2 deliveries today • Last update: 4 min ago</div>
          </div>
          <div class="driver-status active">
            <div class="driver-status-dot"></div>
            <span>On Delivery</span>
          </div>
        </div>

        <div class="driver-card active">
          <div class="driver-avatar-large">LW</div>
          <div class="driver-info">
            <div class="driver-name">Linda Wang</div>
            <div class="driver-details">4 deliveries today • Last update: 1 min ago</div>
          </div>
          <div class="driver-status active">
            <div class="driver-status-dot"></div>
            <span>On Delivery</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>